import { makeAutoObservable } from "mobx";
import { Workspace } from "@/modules/main/Workspace";

export class OfflineState {
  constructor(public workspace: Workspace) {
    makeAutoObservable(this);
  }
}
